import * as types from '../actions/actionTypes';

const commentsReducerDefaultState = [];

export default function commentsReducer(
    state = commentsReducerDefaultState,
    action
) {
    const { comments } = action;
    switch (action.type) {
        case types.GET_COMMENTS:
            return [...comments];
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/comments.js